import axios from 'axios';
import {systemEnvironmentApiUrl} from '../../../helpers/url';

/**
 * @param parameters
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getContacts(parameters = {}, locatorType) {
    let type = ['contacts', 'calculation'].indexOf(locatorType) !== -1 ? 'contact/search' : locatorType;
    if (locatorType === 'calculation') {
        parameters.withContactForCalculation = true;
        type = 'shops';
    }
    return axios
        .post(`${systemEnvironmentApiUrl()}/api/v1/${type}`, parameters)
        .then((response) => response.data);
}



// WEBPACK FOOTER //
// ./src/components/locator/api/locator.js